import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import logo from '../../assets/images/artwer/logo-dark-text.png';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.paddingTop = '';
  }, []);

  return (
    <div className="homestyle2">
      <header className="artwer-subpage-header">
        <div className="container">
          <Link to="/" aria-label="ART-WER — naar home">
            <img src={logo} className="artwer-subpage-logo" alt="ART-WER Aannemingsbedrijf" />
          </Link>
          <Link to="/" className="thm-btn-two artwer-subpage-back">Naar home</Link>
        </div>
      </header>

      <main id="main-inhoud">
      <section className="artwer-legal-page">
        <div className="container">
          <h1>Privacyverklaring</h1>
          <p className="artwer-legal-page__meta">ART-WER Aannemingsbedrijf · laatst bijgewerkt: juni 2026</p>

          <p>
            ART-WER respecteert uw privacy en verwerkt persoonsgegevens uitsluitend in
            overeenstemming met de Algemene Verordening Gegevensbescherming (AVG). In deze
            verklaring leest u welke gegevens wij verwerken, waarom en welke rechten u heeft.
          </p>

          <h2>1. Verwerkingsverantwoordelijke</h2>
          <p>
            ART-WER Aannemingsbedrijf (eenmanszaak)<br />
            Lucernehof 15, 8256 CH Biddinghuizen<br />
            KvK 54517702 · BTW NL002522645B88<br />
            E-mail: <a href="mailto:info@art-wer.nl">info@art-wer.nl</a> · Telefoon:{' '}
            <a href="tel:+31616136942">+31 6 16 13 69 42</a>
          </p>

          <h2>2. Welke gegevens wij verwerken</h2>
          <ul>
            <li>
              <strong>Contactgegevens die u zelf verstrekt</strong> wanneer u ons belt, e-mailt of via
              WhatsApp benadert (naam, telefoonnummer, e-mailadres, adres/locatie en de inhoud van uw
              bericht).
            </li>
            <li>
              <strong>Technische gegevens</strong> die uw browser automatisch verstuurt bij het laden
              van de kaart op de contactpagina (zie punt 4): met name uw IP-adres.
            </li>
          </ul>

          <h2>3. Doel en grondslag</h2>
          <p>
            Wij gebruiken uw gegevens om uw vraag te beantwoorden, een opname in te plannen en een
            offerte uit te brengen, en om — als u opdracht geeft — de werkzaamheden uit te voeren. De
            grondslag hiervoor is de uitvoering van (de aanloop naar) een overeenkomst en ons
            gerechtvaardigd belang om met u te communiceren. Wij gebruiken uw gegevens niet voor
            marketing of profilering en verkopen ze niet aan derden.
          </p>

          <h2>4. Externe diensten en ontvangers</h2>
          <ul>
            <li>
              <strong>OpenStreetMap</strong> — op de contactpagina tonen wij een kaart van ons
              werkgebied. Hierbij wordt uw IP-adres verwerkt door de OpenStreetMap Foundation om de
              kaarttegels te laden.
            </li>
            <li>
              <strong>WhatsApp (Meta)</strong> — als u de WhatsApp-knop gebruikt, verloopt het gesprek
              via WhatsApp/Meta en gelden hun voorwaarden en privacybeleid.
            </li>
            <li>
              <strong>Hosting- en e-mailprovider</strong> — onze website en e-mail worden gehost bij een
              dienstverlener die gegevens uitsluitend in onze opdracht verwerkt.
            </li>
          </ul>
          <p>
            Onze website laadt geen Google Fonts of andere externe scripts van derden, en plaatst geen
            tracking- of advertentiecookies.
          </p>

          <h2>5. Cookies</h2>
          <p>
            Wij plaatsen geen tracking-, analyse- of advertentiecookies. Er is daarom geen
            cookiebanner nodig.
          </p>

          <h2>6. Bewaartermijn</h2>
          <p>
            Wij bewaren uw gegevens niet langer dan nodig: offerte- en contactgegevens tot maximaal
            twee jaar na het laatste contact, en gegevens die bij een opdracht horen zolang de wettelijke
            (fiscale) bewaarplicht van zeven jaar dat vereist.
          </p>

          <h2>7. Beveiliging</h2>
          <p>
            De website is uitsluitend bereikbaar via een beveiligde verbinding (HTTPS). Wij nemen
            passende technische en organisatorische maatregelen om uw gegevens te beschermen.
          </p>

          <h2>8. Uw rechten</h2>
          <p>
            U heeft het recht op inzage, correctie, verwijdering, beperking en overdracht van uw
            gegevens, en het recht om bezwaar te maken tegen de verwerking. Neem hiervoor contact op via{' '}
            <a href="mailto:info@art-wer.nl">info@art-wer.nl</a>. Bent u het niet eens met hoe wij met uw
            gegevens omgaan, dan kunt u een klacht indienen bij de Autoriteit Persoonsgegevens
            (autoriteitpersoonsgegevens.nl).
          </p>

          <h2>9. Wijzigingen</h2>
          <p>
            Wij kunnen deze privacyverklaring aanpassen. De meest actuele versie vindt u altijd op deze
            pagina.
          </p>
        </div>
      </section>
      </main>

      <FooterTwo />
    </div>
  );
};

export default Privacy;
